/** @module Apparel/ProductSourcesMatrices */
define([
	"csi/_base/underscore",
	"csi/table/matrix/Path",
	"csi/xml",
	"dojo/_base/declare"
], function(_,PathMatrix,xml,declare) {

	return declare(PathMatrix, {

		/**
		 * @override
		 * Filters nodes based on whether their Supplier Request's state is a draft or not
		 */
		_filterNodes: function(ctx, spec, nodes) {
			return _.filter(nodes, function(node) {
				var path = node.$Type == "SupplierItem" ? "Child:QuoteSRLineItem/Child:__Parent__" : "Child:SampleSRLineItem/Child:__Parent__";
				var supplierRequest = ctx.cache.getPathNode(node, path);
				
				if (!supplierRequest) {
					return false;
				}
				var state = xml.enumGetText(supplierRequest.State);
				return state == "Issued" || state == "Complete";
			});
		}
	});
});